import $ from 'jquery';
import React, { useContext, useEffect, useState } from 'react';
import SessionManager from '../../routes/SessionManager';
import CommonUtils from '../../util/CommonUtils';
import { Modal, Button, Popover } from 'antd';
import AdvWorkHrsBreadcumb from './AdvWorkHrsBreadcumb';
import WorkHrsBreadcumb from './WorkHrsBreadcumb';
import moment from 'moment';
import ReactGA from "react-ga4";
import { Context } from '../../views/app';

const BreadCrumb = (props) => {
    let appContex = useContext(Context);
    let user = appContex.user;
    let AdvWorkHrsBreadCrumbRef = React.createRef();
    let WorkHrsBreadCrumbRef = React.createRef();

    const date = props.date ? props.date : "";
    const [work_schedule, setWorkSchedule] = useState([]);
    const [breadcrumbs, setBreadCrumbs] = useState([]);
    const [sites, setSites] = useState([]);
    const [disableButton, setDisableButton] = useState(true);
    const [showAdvancedWorkHrs, setShowAdvancedWorkHrs] = useState(false);
    const [advWorkHours, setAdvWorkHours] = useState(null);
    const [work_hours_start, setWorkHoursStart] = useState(null);
    const [work_hours_end, setWorkHoursEnd] = useState(null);

    if (!user.page_queue)
        user.page_queue = [window.location.pathname, ""];

    let page_queue = user.page_queue;
    //console.log('page_queue - 1', page_queue);
    if (['/dashboard-exec'].includes(window.location.pathname)) {
        console.log('window.location.pathname', window.location.pathname)
        user.page_queue = [page_queue ? page_queue[0] : "", page_queue ? page_queue[0] : ""];
    } else {
        if (page_queue[0] !== window.location.pathname)
            user.page_queue = [window.location.pathname, page_queue[0]];
    }

    appContex.updateUser(user);
    //console.log('page_queue - 2', page_queue);

    useEffect(() => {
        setTimeout(() => {
            makeBannerFloat();
        }, 500);
        let page = window.location.pathname.toLocaleUpperCase().replace(/-/g, ' ');
        ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: page.replace(/\//g, '» ') });
        let breadcrumbs = getBreadcrumbs(window.location, date);
        let sessionManager = new SessionManager();
        let user_activity = sessionManager.readCookie('user_activity', false);
        let user = appContex.user;
        if (user_activity) {

            user_activity.site_activity = user_activity && user_activity.site_activity ? user_activity.site_activity : [];
            user_activity.site_id = user_activity && user_activity.site_id ? user_activity.site_id : [];

            let site_activity_length = user_activity && user_activity.site_activity ? user_activity.site_activity.length : 0;

            if (site_activity_length > 0 && user_activity.site_activity[site_activity_length - 1].site === user.site_selected.site_name) {
                if (window.location.pathname === "/dashboard/zone-history") {
                    user_activity.site_activity[site_activity_length - 1].activity.push({ "page": window.location.pathname, "location": user.zone_selected && user.zone_selected.location_name, "timestamp": new Date().getTime() });
                } else {
                    user_activity.site_activity[site_activity_length - 1].activity.push({ "page": window.location.pathname, "timestamp": new Date().getTime() });
                    user_activity.site_activity[site_activity_length - 1].end_time = new Date().getTime();
                }
            } else {
                if (user.site_selected) {
                    user_activity.site_activity.push({ "activity": [{ "page": window.location.pathname, "timestamp": new Date().getTime() }], "site": user.site_selected.site_name, "start_time": new Date().getTime(), "end_time": new Date().getTime(), "site_id": user.site_selected.site_id, "customer_id": user.site_selected.customer_id });
                    user_activity.site_id.push(user.site_selected.site_id);
                }
            }
            sessionManager.storeCookie("user_activity", user_activity);
        }

        setBreadCrumbs(breadcrumbs.breadcrumbs);
        // setselectedHref(breadcrumbs.selectedHref);
        if (user.site_selected) {
            setWorkHours(user.site_selected);
        }
        //once sites state is updated, do not call the API
        else if (sites.length === 0) {
            fetchSiteLocations();
        }
        $('[data-toggle="dropdown"]').dropdown();
    }, [props, sites]);

    useEffect(() => {
        if (sites.length > 0) {
            let site_default = sites.find(site => site.site_id === user.site_id);
            if (site_default === undefined) {
                site_default = sites[0];
            }
            if (site_default) {
                setWorkHours(site_default);
            }
            user = appContex.user
        }
    }, [sites]);

    let getBreadcrumbs = ({ pathname }, date) => {
        let sessionManager = new SessionManager();
        let user = sessionManager.readCookie('user');
        if (!user)
            return;

        let dashboard = user.default_dashboard === "Map View" ? '/map-view' : user.default_dashboard === "Site Map" ? '/sitemap' : '/dashboard';
        let breadcrumbs = [];

        switch (pathname) {
            case "/dashboard":

                if (user.page_queue && user.page_queue[1] === '/dashboard-exec') {
                    breadcrumbs.push({ name: "Executive Dashboard", href: "/dashboard-exec" });
                }

                user.default_dashboard = 'Dashboard';
                sessionManager.storeCookie('user', { ...user });
                if (user.site_selected) {
                    breadcrumbs.push({ name: user.site_selected.site_name });
                }
                breadcrumbs.push({ name: "Dashboard", href: "/dashboard" });
                break;

            case "/dashboard-exec":
                user.default_dashboard = 'Executive Dashboard';
                sessionManager.storeCookie('user', { ...user });
                breadcrumbs.push({ name: "Executive Dashboard", href: "/dashboard-exec" });
                break;

            case "/dashboard/zone-history":
                breadcrumbs.push({ name: "Zone History", href: '/dashboard/zone-history' });
                break;

            case "/sensors-dashboard":
                breadcrumbs.push({ name: "Sensor Dashboard", href: '/sensors-dashboard' });
                break;

            case "/sitemap":
                user.default_dashboard = 'Site Map';
                sessionManager.storeCookie('user', { ...user });
                if (user.site_selected) {
                    breadcrumbs.push({ name: user.site_selected.site_name });
                }
                breadcrumbs.push({ name: 'Site Map', href: "/sitemap" });
                break;

            case "/map-view":
                user.default_dashboard = 'Map View';
                sessionManager.storeCookie('user', { ...user });
                if (user.site_selected) {
                    breadcrumbs.push({ name: user.site_selected.site_name });
                }
                breadcrumbs.push({ name: 'Map View', href: '/map-view' });
                break;

            case "/owners-portal":
                sessionManager.storeCookie('user', { ...user });
                breadcrumbs.push({ name: 'Owners Portal', href: '/owners-portal' });
                break;

            case "/timelapse-dashboard":
                breadcrumbs.push({ name: 'Timelapse Dashboard', href: "/timelapse-dashboard" });
                break;

            case "/site-management":
            case "/settings":
                breadcrumbs.push({ name: 'Site Management', href: pathname });
                break;

            case "/bim-viewer":
                breadcrumbs.push({ name: "BIM Models", href: '/bim-models' });
                breadcrumbs.push({ name: "BIM Viewer", href: '/bim-viewer' });
                break;

            case "/bim-models":
                breadcrumbs.push({ name: "BIM Models", href: '/bim-models' });
                break;

            case "/reports":
                breadcrumbs.push({ name: 'Reports', href: "/reports" });
                break;

            case "/reports/reports-library":
                breadcrumbs.push({ name: "Reports", href: '/reports' });
                breadcrumbs.push({ name: "Reports Library", href: '/reports/reports-library' });
                break;

            case "/profile-settings":
                breadcrumbs.push({ name: 'Profile Settings', href: "/profile-settings" });
                break;

            case "/videos":
                breadcrumbs.push({ name: "Videos", href: '/videos' });
                break;

            case "/videos/timelapse-video":
                breadcrumbs.push({ name: "Videos", href: '/videos' });
                breadcrumbs.push({ name: "Timelapse Video", href: '/videos/timelapse-video' });
                break;

            case "/videos/video-library":
                breadcrumbs.push({ name: "Videos", href: '/videos' });
                breadcrumbs.push({ name: 'Video Library', href: "/videos/video-library" });
                break;

            case "/support/how-to-videos":
                breadcrumbs.push({ name: "Support" });
                breadcrumbs.push({ name: "How To Videos", href: '/support/how-to-videos' })
                break;

            case "/support/faqs":
                breadcrumbs.push({ name: "Support" });
                breadcrumbs.push({ name: "FAQ", href: '/support/faqs' });
                break;

            case "/support/third-party-monitoring":
                breadcrumbs.push({ name: "Support" });
                breadcrumbs.push({ name: "Third Party Monitoring", href: '/support/third-party-monitoring' });
                break;

            case "/admin-console":
                breadcrumbs.push({ name: "Admin Console", href: '/admin-console' });
                break;

            case "/ppe-reports-library":
                breadcrumbs.push({ name: "PPE Reports Library", href: "/ppe-reports-library" });
                break;

            case "/file-dashboard":
                breadcrumbs.push({ name: "Reports", href: '/reports' });
                breadcrumbs.push({ name: "Site Plans", href: '/file-dashboard' });
                break;

            default:
                break;

        }

        let site_selected_path = [
            "/dashboard/zone-history",
            "/sensors-dashboard",
            "/timelapse-dashboard",
            "/site-management",
            "/bim-viewer",
            "/bim-models",
            "/file-dashboard",
            "/reports",
            "/reports/reports-library",
            "/videos",
            "/videos/timelapse-video",
            "/videos/video-library",
            "/support/third-party-monitoring",
            "/admin-console",
            "/settings"];


        if (user.site_selected && (CommonUtils.hasPermission('SITESUPT-UI-DASHBOARD-SITES') || CommonUtils.hasPermission('SITESUPT-UI-DASHBOARD-SITEMAP'))) {
            if (pathname.includes("/dashboard/"))
                breadcrumbs.unshift({ name: user.default_dashboard, href: dashboard });
            if (site_selected_path.includes(pathname)) {
                breadcrumbs.unshift({ name: user.site_selected.site_name, href: dashboard });
            }
        }


        if (date)
            breadcrumbs.push({ name: date, href: "/dashboard/zone-history" })

        return ({ breadcrumbs: breadcrumbs, selectedHref: dashboard });
    }

    let fetchSiteLocations = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    console.log('hello guys');
                    let sites = res.data ? res.data.filter(x => x.site_state !== 'Inactive') : [];
                    let loc = 'site_name';
                    sites = sites.sort((a, b) => a[loc] > b[loc] ? 1 : a[loc] < b[loc] ? -1 : 0);
                    setSites(sites);
                }
            }
        );
    }

    let convert12to24HrsFormat = (hr, isAdvanced = true) => {
        if (isAdvanced) {
            let isEnd = hr < 0;
            if (isEnd)
                hr = (hr * -1) + 1;
            hr = hr - 1; // we incremented method caller level by 1 to take care of -0 scenario.
            var m1 = moment().startOf('day');
            let hours = [];
            while (hours.length < 48) {
                hours.push(m1.format('h:mmA'));
                m1 = m1.add(30, 'minutes');
            }
            return hours[hr] ? hours[hr] : '12:00AM';
        } else {
            if (hr > 12) {
                hr -= 12;
                hr += ":00 PM";
            } else if (hr === 0) {
                hr = "12:00 AM"
            } else if (hr === 12) {
                hr = "12:00 PM"
            }
            else {
                hr += ":00 AM"
            }
            return hr;
        }
    }

    let setWorkHours = (site_selected) => {
        let advWorkHours = site_selected.site_config.work_hours.extended_enabled === undefined ? false : site_selected.site_config.work_hours.extended_enabled;
        setAdvWorkHours(advWorkHours);
        const weekday = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
        let day = new Date().getDay();
        let today = weekday[day];
        if (!advWorkHours) {
            let work_hours_start = -1;
            let work_hours_end = -1;
            if ((day !== 0 && day !== 6) || ((day === 0 || day === 6) && site_selected.site_config.work_hours.include_weekends === "6 7") || (day === 6 && site_selected.site_config.work_hours.include_weekends === "6") || (day === 0 && site_selected.site_config.work_hours.include_weekends === "7")) {
                work_hours_start = parseInt(site_selected.site_config.work_hours.work_hours_start.replace(":00", ''));
                work_hours_end = parseInt(site_selected.site_config.work_hours.work_hours_end === "23:59" ? 0 : site_selected.site_config.work_hours.work_hours_end.replace(":00", ''));

                work_hours_start = convert12to24HrsFormat(work_hours_start, false);
                work_hours_end = convert12to24HrsFormat(work_hours_end, false);
            }
            setWorkHoursStart(work_hours_start);
            setWorkHoursEnd(work_hours_end);
        } else {
            let slot_hrs = [];
            let todaySchedule = CommonUtils.hasPath(site_selected, 'site_config.work_hours.work_schedule.' + today);
            if (todaySchedule) {
                let hrs = todaySchedule ? site_selected.site_config.work_hours.work_schedule[today] : [];
                if (hrs.length === 24) { // Backward compat for 24 len array.
                    let tmp = JSON.parse(JSON.stringify(hrs));
                    hrs = Array(48).fill(0);
                    for (let i = 0; i < tmp.length; i++)
                        if (tmp[i] === 1) {
                            hrs[(2 * i)] = 1;
                            hrs[(2 * i) + 1] = 1;
                        }
                }
                var slots = [];
                var zeroOrOne = hrs && hrs.length > 0 && hrs[0];
                var slot = [];
                for (var i = 0; i <= hrs.length; i++) {
                    if (hrs[i] === zeroOrOne) {
                        slot.push(i)
                    } else {
                        slots.push({ [zeroOrOne]: slot });
                        zeroOrOne = hrs[i];
                        slot = [i];
                    }
                }
                slot_hrs = slots.filter(t => parseInt(Object.keys(t)[0]) === 1);
            }
            setWorkSchedule(slot_hrs);
        }
    }

    let openModal = () => {
        setShowAdvancedWorkHrs(true);
    }

    let closeModal = () => {
        setShowAdvancedWorkHrs(false);
    }

    let resetSiteConfig = () => {
        if (advWorkHours) {
            AdvWorkHrsBreadCrumbRef.resetAdvancedWorkHours();
        } else {
            WorkHrsBreadCrumbRef.resetWorkHours();
        }
        setDisableButton(true);
    }

    let updateSiteConfig = () => {
        if (advWorkHours) {
            AdvWorkHrsBreadCrumbRef.updateSiteConfig();
        } else {
            WorkHrsBreadCrumbRef.updateSiteConfig();
        }
        setDisableButton(true);
    }

    let disableButtons = () => {
        if (advWorkHours) {
            AdvWorkHrsBreadCrumbRef.isChanged() ? setDisableButton(false) : setDisableButton(true);
        } else {
            WorkHrsBreadCrumbRef.isChanged() ? setDisableButton(false) : setDisableButton(true);
        }
    }
    var content = (<></>);
    if (!advWorkHours) {
        content = work_hours_start !== -1 && work_hours_end !== -1 ? (<div>{work_hours_start} to {work_hours_end}</div>) : (<div>No Work Hours Available</div>);
    } else {
        content = (<div>
            {work_schedule.length > 0 ? work_schedule.map((item, i) => {
                return <ul key={i} style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                    <li>{` ${convert12to24HrsFormat((item['1'][0]) + 1)}`} to {convert12to24HrsFormat(-(parseInt(item['1'].slice(-1)) + 1))}</li>
                </ul>
            }) : <li>No slot selected</li>}
        </div>
        );
    }

    let dueDate = user.site_selected.due_date;
    let due_date_counter = 365;
    if (user.site_selected.past_due) {
        due_date_counter = 0;
        if (dueDate) {
            due_date_counter = moment(dueDate, 'YYYY-MM-DD').diff(moment(), 'days');
            due_date_counter += 1;
            console.log('Due Counter: ', due_date_counter);
        }
    }

    let makeBannerFloat = () => {
        const navBar = $('.nav');
        const bcrumbRow = $('#breadcrumb-row');
        //console.log(navBar.height());
        //console.log($(bcrumbRow).css('margin-top'));
        //console.log(bcrumbRow.height());

        if (bcrumbRow && bcrumbRow.length > 0) {
            $(bcrumbRow).css('top', navBar.height() + 8);
            const expiryBannerRow = $('#expiry-banner');
            $(expiryBannerRow).css('margin-top', bcrumbRow.height() + $(bcrumbRow).offset().top + 15);
            $('.page-container').css('margin-top', bcrumbRow.height() + $(bcrumbRow).offset().top + 70);
        }
    }

    return (
        <React.Fragment>

            <nav aria-label="breadcrumb">
                <span className="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
                {user.site_locations && user.site_locations.length > 0 && breadcrumbs.length > 0 &&
                    <ol className="breadcrumb p-2" id="breadcrumb-row">
                        {breadcrumbs.map((breadcrumb, i) =>
                            <li aria-current="page" key={i} className="breadcrumb-item font-size-13">
                                <a className="btn-link" href={breadcrumb.href}>{breadcrumb.name}</a>
                            </li>)
                        }

                        {!['/dashboard-exec'].includes(window.location.pathname) && <li className='font-size-13 ml-auto' style={{ color: "#007BFF" }}>
                            <Popover content={content} title={<span><b>Work Hours</b> - {moment().format('dddd')}</span>}>
                                <span className='text-primary font-size-12 px-2 cursor-pointer'>Today's Work Hours</span>
                            </Popover>
                            <>
                                <b className='pipe-separator'>|</b>
                                <span className='text-primary font-size-12 px-2 cursor-pointer' style={{ cursor: "pointer" }} onClick={openModal}>Weekly Work Hours Schedule</span>
                            </>
                        </li>
                        }
                    </ol>
                }
            </nav>
            <Modal
                title={advWorkHours ? "Advanced Work Hours" : "Standard Work Hours"}
                bodyStyle={{ padding: '9px 21px' }}
                footer={CommonUtils.hasPermission("SITESUPT-UI-SITE-MGMT") && [
                    <Button key='reset' size='small' className="btn reset-changes" danger onClick={resetSiteConfig} disabled={disableButton}>Reset</Button>,
                    <Button key='save' size='small' className="btn btn-primary text-white" onClick={updateSiteConfig} disabled={disableButton}>Save</Button>
                ]}
                onOk={updateSiteConfig}
                width={700}
                destroyOnClose={true}
                closeIcon={<div style={{ marginTop: "-5px" }}><i className="fa fa-lg fa-times-circle pb-3 text-white" onClick={closeModal}></i></div>}
                open={showAdvancedWorkHrs}
            >
                <div aria-labelledby='headingOne'>
                    <div className='card-body bg-white border-light'>
                        {advWorkHours ? <AdvWorkHrsBreadcumb ref={x => AdvWorkHrsBreadCrumbRef = x} disableButtons={disableButtons} /> : <WorkHrsBreadcumb ref={x => WorkHrsBreadCrumbRef = x} disableButtons={disableButtons} />}
                    </div>
                </div>
            </Modal>
            {user.user_role !== 209 && user.site_selected && (due_date_counter <= 60) && <><div id="expiry-banner" className={"fixed-top p-2 " + (due_date_counter > 0 ? "bg-warning text-dark" : "bg-danger text-white")} style={{ zIndex: 500, marginTop: "87px", textAlign: "center", fontWeight: due_date_counter > 0 ? "" : "bold" }}>{due_date_counter > 0 ? "Reminder:" : ""} Your account is {due_date_counter > 0 ? "due in " + due_date_counter + " days!" : "past due and at risk of suspension."}  For assistance, please contact our support team at support@sitekick.com or call us at 612-605-3170.</div> <br /></>}
        </React.Fragment >
    );
}

export default BreadCrumb;